/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Faq_A5Inputs */

const en_to_yaml_faq_a5 = /** @type {(inputs: To_Yaml_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, and more carefully than you might expect. Values that a YAML 1.1 reader could coerce into a boolean or a number are quoted automatically. The strings "yes", "no", and "1.10" all come out quoted so they read back as strings.`)
};

const ko_to_yaml_faq_a5 = /** @type {(inputs: To_Yaml_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`그렇습니다. 그리고 예상보다 더 조심스럽게 처리합니다. YAML 1.1 리더가 불리언이나 숫자로 강제 변환할 수 있는 값은 자동으로 인용됩니다. 문자열 "yes", "no", "1.10"은 모두 문자열로 다시 읽히도록 인용되어 나옵니다.`)
};

const ja_to_yaml_faq_a5 = /** @type {(inputs: To_Yaml_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。しかも思った以上に慎重に扱います。YAML 1.1 のリーダが真偽値や数値へ強制変換しうる値は自動で引用されます。文字列 "yes", "no", "1.10" はいずれも文字列として読み戻されるよう引用されて出ます。`)
};

/**
* | output |
* | --- |
* | "Yes, and more carefully than you might expect. Values that a YAML 1.1 reader could coerce into a boolean or a number are quoted automatically. The strings \"y..." |
*
* @param {To_Yaml_Faq_A5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_faq_a5 = /** @type {((inputs?: To_Yaml_Faq_A5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Faq_A5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_faq_a5(inputs)
	if (locale === "ko") return ko_to_yaml_faq_a5(inputs)
	return ja_to_yaml_faq_a5(inputs)
});